import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getAllProposedContent } from 'components/ThinkTanks/modules/actions';
import Content from '../components/Content';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.themeTableDetail,
    allProposedContent: state.thinkTanks.allProposedContent,
    calls: state.narratives.list,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAllProposedContent: bindActionCreators(getAllProposedContent, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Content));



// WEBPACK FOOTER //
// ./src/components/Content/container/index.js